// Modo de pantalla: el mismo que ya usa el sistema de El Niño.
// "sol" sube el contraste para leer al aire libre; "noche" baja la luz.
// La clase vive en <html> y el CSS de index.css hace el resto.

export const MODOS = ['dia', 'sol', 'noche']

const CLASES = { dia: '', sol: 'modo-sol', noche: 'modo-noche' }
const STORAGE_KEY = 'modo-pantalla'

export const INFO_MODO = {
  dia: { nombre: 'Normal', detalle: 'Papel claro, el de siempre' },
  sol: { nombre: 'Modo sol', detalle: 'Más contraste para leer a la intemperie' },
  noche: { nombre: 'Modo oscuro', detalle: 'Menos luz y menos batería de noche' },
}

const guardado = () => {
  try {
    const v = localStorage.getItem(STORAGE_KEY)
    return MODOS.includes(v) ? v : null
  } catch {
    return null
  }
}

const aplicarClase = (modo) => {
  const html = document.documentElement
  Object.values(CLASES).forEach((c) => c && html.classList.remove(c))
  if (CLASES[modo]) html.classList.add(CLASES[modo])
}

// Se llama una vez al arrancar, antes de renderizar React.
// A propósito NO sigue el prefers-color-scheme del sistema: el sistema siempre fue
// claro y a nadie le tiene que cambiar de golpe porque tenga el celular en oscuro.
// El modo se elige a mano con el botón, y ahí sí queda guardado.
export const iniciarModoPantalla = () => aplicarClase(guardado() || 'dia')

export const modoActual = () => {
  const html = document.documentElement
  if (html.classList.contains(CLASES.noche)) return 'noche'
  if (html.classList.contains(CLASES.sol)) return 'sol'
  return 'dia'
}

export const cambiarModo = (modo) => {
  if (!MODOS.includes(modo)) return modoActual()
  aplicarClase(modo)
  try {
    localStorage.setItem(STORAGE_KEY, modo)
  } catch {
    // navegador con storage bloqueado: el modo vale para esta sesión y listo
  }
  return modo
}
